module.exports = __webpack_public_path__ + "static/lato-regular-056a373d808ada4f12a2d6538e88823c.eot";